// extracted by mini-css-extract-plugin
export var errorInput = "Y_cL";
export var errorLabel = "Y_cH";
export var inputContainer = "Y_cV";
export var inputNumber = "Y_cW";
export var inputPercentage = "Y_cX";
export var textInput = "Y_cY";
export var textInputDefault = "Y_cZ";
export var textlabel = "Y_cJ";